<div *ngIf="(isVisible$ | async) && (menuItems$ | async)?.length > 0" class="grey-25-bg" data-elastic-exclude>
  <div class="footer grid-col-12 grid-max-width">
    <div class="left-navi-section grey-25-bg col-f sm-col-1-9 md-col-1-9 ps-xxlarge">
      <fcom-icon
        aria-hidden="true"
        class="nordic-blue-900-text finnair-emblem-medium"
        name="finnair-emblem"
        category="custom"
      ></fcom-icon>
      <div class="footer-section ms-small-t flex flex--wrap">
        <nav
          class="section-block"
          *ngFor="let item of (menuItems$ | async)?.slice(1, -1); let i = index"
          attr.aria-labelledby="{{ 'footer-section-nav-' + i }}"
        >
          <h2
            [id]="'footer-section-nav-' + i"
            class="links-list-heading inline-block font-body-1 nordic-blue-900-text ms-xlarge-t"
          >
            {{ item.teaserTitle }}
          </h2>
          <ul *ngIf="item.items" role="list" class="links-list flex flex--space-between no-list-style">
            <li *ngFor="let child of item.items" role="listitem">
              <a
                class="block no-underline nordic-blue-900-text font-body-2 ps-xsmall-y footer-link inline-block"
                *ngIf="child.link"
                [finLink]="child.link"
                [finElemTracker]="'footer-left-section: ' + child.link"
                [finElemContext]="'footer'"
                [finElemType]="ElementTypes.LINK"
                [external]="child.external"
                [nofollow]="child.subjectTaxonomyTags?.includes(CmsTaxonomy.LINK_NOFOLLOW)"
                [attr.target]="child.openInNewTab ? '_blank' : ''"
              >
                <span class="valign-middle">{{ child.teaserTitle }}</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="right-navi-section col-f sm-col-10-12 md-col-10-12 partner-wrapper grey-25-bg flex flex--column">
      <span class="copyright-title font-body-1 nordic-blue-900-text regular-type"
        >{{ copyrightBanner$ | finMap: 'copyright' | async }} {{ year }}</span
      >
      <span
        class="licence font-body-1 nordic-blue-900-text regular-type"
        [innerHTML]="copyrightBanner$ | finMap: 'licensesHTML' | async"
      ></span>
      <nav class="copyright-links">
        <ul *ngFor="let item of (menuItems$ | async)?.slice(-1)" class="clear no-list-style">
          <ng-container *ngIf="item.items">
            <li *ngFor="let child of item.items">
              <a
                [finLink]="child.link"
                [external]="child.external"
                [finElemTracker]="'footer-right-section: ' + child.link"
                [finElemContext]="'footer'"
                [finElemType]="ElementTypes.LINK"
                class="nordic-blue-900-text font-body-2 no-underline footer-link inline-block"
                >{{ child.htmlTitle || child.teaserTitle }}</a
              >
            </li>
          </ng-container>
        </ul>
      </nav>
    </div>
  </div>
</div>
